import { ReactComponent as AlertIcon } from '../assets/icons/main/alertIcon.svg';
import {palette} from '../theme/palette';
import {
    Card,
    CardContent,
    CardHeader,
    DialogTitle,
    Grid,
    TextField,
    Typography,
    Button,
    Stack,
    Box,
  } from '@mui/material';
const NotAuthorized = ()=>{
    return(
        <div style={{textAlign:'center', display:'flex', justifyContent:'center', alignItems:'center', height:'80vh', flexDirection:'column'}}>
            <AlertIcon style={{ height: '150px', width: '150px', color : palette.warning.main  }}/>
            <Typography variant='h1' m={5}>Not Authorized</Typography>
            <Typography>
                You do not have permission to access this page. If you believe this is a mistake, please contact your administrator or try logging in with a different account.
            </Typography>
        </div>
    )
}
export default NotAuthorized;